import { create } from "zustand";
import type { MessageInsight } from "../types/messageInsight";

interface MessageInsightState {
  insights: Record<string, MessageInsight>;
  addInsight: (insight: MessageInsight) => void;
  clearInsights: () => void;
}

export const useMessageInsightStore = create<MessageInsightState>((set) => ({
  insights: {},

  addInsight: (insight) =>
    set((state) => ({
      insights: {
        ...state.insights,
        [insight.messageId]: insight,
      },
    })),

  clearInsights: () => set({ insights: {} }),
}));
